module.exports = __webpack_public_path__ + "static/media/Dot.201724bf.svg";